<template>
  <v-menu :close-on-content-click="false"
          max-width="400px"
          nudge-top="300"
          v-model="isMenuOpened">
    <template v-slot:activator="{ on }">
      <div class="d-flex align-center mt-4">
        <span class="kbDarkBlueText--text d-block mr-3 font-weight-medium"
              style="font-size: 18px">
          {{ $t('general.extraData') }}
        </span>
        <v-btn fab width="25px" height="25px" color="white" v-on="on">
          <v-icon color="kbBlue" size="20px">mdi-filter</v-icon>
        </v-btn>
      </div>
    </template>

    <template>
      <v-tabs
        v-model="tab"
        background-color="kbLight"
        color="kbBlue"
        grow
      >
        <v-tab>
          {{ $t('general.orderExtraData') }}
        </v-tab>
        <v-tab>
          {{ $t('general.tags') }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ExtraDataFilteringItems :all-items="allExtraData"
                                   :is-menu-opened="isMenuOpened"
                                   :loading="loading"
                                   :not-items-found-text="$t('general.noExtraDataFound')"
                                   :selected-items="selectedExtraData"
                                   text-key="field"
                                   value-key="value"
                                   @closeComponent="closeMenu()"
                                   @onColumnsChange="onColumnsChange({ columns: $event, itemsToChange: 'extraData' })" />
        </v-tab-item>
        <v-tab-item>
          <ExtraDataFilteringItems :all-items="allExtraDataTags"
                                   :is-menu-opened="isMenuOpened"
                                   :loading="loading"
                                   :not-items-found-text="$t('general.noTags')"
                                   :selected-items="selectedExtraDataTags"
                                   @closeComponent="closeMenu()"
                                   @onColumnsChange="onColumnsChange({ columns: $event, itemsToChange: 'tags' })" />
        </v-tab-item>
      </v-tabs-items>
    </template>
  </v-menu>
</template>

<script>
import ExtraDataFilteringItems from './ExtraDataFilteringItems'
export default {
  components: { ExtraDataFilteringItems },
  data () {
    return {
      isMenuOpened: false,
      loading: false,
      tab: 0
    }
  },
  methods: {
    closeMenu () {
      this.isMenuOpened = false
    },
    onColumnsChange ({ columns, itemsToChange }) {
      this.$emit('onColumnsChange', { columns, itemsToChange })
    }
  },
  props: {
    allExtraData: {
      type: Array,
      default: () => []
    },
    allExtraDataTags: {
      type: Array,
      default: () => []
    },
    personExtraDataTagsFilterMethod: {
      type: String,
      default: 'extraData'
    },
    selectedExtraData: {
      type: Array,
      default: () => []
    },
    selectedExtraDataTags: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    isMenuOpened (value) {
      if (value) {
        this.tab = this.personExtraDataTagsFilterMethod === 'extraData' ? 0 : 1
      }
    }
  }
}
</script>
